import * as R from 'ramda';
import moment from 'moment';

export default function SendNotificationsDialogController(
  $rootScope,
  $scope,
  $q,
  ssDialogService,
  alerts,
  loaderService,
  vmDataService,
  vmSharedModelService,
) {
  const vm = this;

  vm.originalCustomerAssetTypeId = -1;
  vm.customerAssetTypeId = -1;

  vm.deleteIsSelected = false;
  vm.hasData = true;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSendNotifications = _handleSendNotifications;
  vm.handleSelectAll = _handleSelectAll;
  vm.handleSelectNotificationChange = _handleSelectNotificationChange;
  vm.handleSelectRecipientChange = _handleSelectRecipientChange;
  vm.selectedList = [];
  vm.totalCount = 0;
  
  activate();

  /** ************************************************
   * Event Handlers
   */

  function activate() {
    vm.totalCount = 0;
    for (const [key, value] of Object.entries(vm.alertList)) {
        value.forEach((alert) => {
          if(alert.alertRecipients && alert.alertRecipients.length > 0){
            vm.totalCount +=1;
          }          
          alert.dueDateText = _displayDate(key, alert);
          _displayAlertRecipientNames(alert, alert.alertRecipients)     
      })
    }
  }

  function _handleSendNotifications($event) {
    if ($scope.sendNotificationsDialogForm.$valid) {
      const sentAlertsList = {};

      for (const [key, value] of Object.entries(vm.alertList)) {
        let selectedAlerts = [];
        value.forEach((alert) => {
          if(alert.isSelected) {
            if(!alert.nonSelectable){
              const selectedRecipients = [];
              alert.recipientList.forEach((rep) => {
                if(rep.isSelected){
                  selectedRecipients.push(...rep.recipients)
                }
              })
              if(selectedRecipients && selectedRecipients.length >0){
                alert.alertRecipients = selectedRecipients;
                selectedAlerts.push(alert);
              }
            }
            
          }     
        })
        if(selectedAlerts && selectedAlerts.length > 0){
          sentAlertsList[key] = selectedAlerts;
        }        
      }

      if(Object.keys(sentAlertsList).length === 0){
        alerts.error('Please select notifications and recipients.');
        return;
      }

      loaderService.showViewLoader = true;
      vmDataService.sendRemindersAlert(sentAlertsList)
        .then((response) => {
          alerts.success('The notifications were sent successfully.');
          loaderService.showViewLoader = false;
        
          _handleCloseDialog();
      }).catch(() => {
        alerts.error('An error occurred while sending notifications.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });;
    }
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.vendorManagement.sendRemindersDialog);
  }

  function _handleSelectAll() {
    for (const [key, value] of Object.entries(vm.alertList)) {
      value.forEach((alert) => {       
        if(!alert.nonSelectable){
          alert.isSelected = vm.selectAll;
          alert.recipientList.forEach((recipient) => {
            if(recipient.recipientName){
              recipient.isSelected = vm.selectAll;
            }           
          })
        }  
      })
    }
        
    vm.changeIsSelected = vm.selectAll;
  }

  function _handleSelectNotificationChange(key, selectedAlert) {
    vm.selectedList = [];
    for (const [key, value] of Object.entries(vm.alertList)) {
      value.forEach((alert) => {
        if(alert.isSelected){
          vm.selectedList.push(alert);
        }                        
      })
    }

    if(!selectedAlert.nonSelectable){
      selectedAlert.recipientList.forEach((r) => {
        if(r.recipientName){
          r.isSelected = selectedAlert.isSelected;
        }        
      })
    }

    vm.changeIsSelected = vm.selectedList.length > 0;
    vm.selectAll = vm.selectedList.length === vm.totalCount;
  }

  function _handleSelectRecipientChange(alert) {
    if(!alert.nonSelectable){
      const selectedList = [];
      let count = 0;
      alert.recipientList.forEach((recipient) => {
        if(recipient.recipientName){
          if(recipient.isSelected){
            count +=1;
          }
        }
       
      })
      if(count == 0 ){
        alert.isSelected = false;
      } else{
        alert.isSelected = true;
      }
    }
   
    vm.selectedList = [];
    for (const [key, value] of Object.entries(vm.alertList)) {
        value.forEach((alert) => {         
          if(alert.isSelected){
            vm.selectedList.push(alert)
          }      
      })
    }

    vm.changeIsSelected = vm.selectedList.length > 0;
    vm.selectAll = vm.selectedList.length === vm.totalCount; 
  }

  /** ************************************************
   * Private Functions
   */

   function _displayDate(key, alert) {
    let formatedDate = ''
    if(key == 'Contracts auto-renewal notification date has passed' ) {
      formatedDate = `Renews on: ${moment(alert.dueDate).format('MM/DD/YYYY')}`;
    } else if(key == 'Contracts approaching auto-renewal notification date') {
      formatedDate = `Notify by: ${moment(alert.thresholdDate).format('MM/DD/YYYY')}`;
    } else if(key=='Risk Assessments upcoming' || key=='Control Reviews upcoming'
       || key == 'COIs upcoming' || key == 'SOCs upcoming') {
      formatedDate =`Due on: ${moment(alert.dueDate).format('MM/DD/YYYY')}`;
    } else if(key =='Contracts will expire') {
      formatedDate =`Expires: ${moment(alert.dueDate).format('MM/DD/YYYY')}`;
    } else if(key == 'Contracts expired' || key == 'Risk Assessments overdue' || key == 'Control Reviews overdue' || key=='COIs overdue' || key == 'SOCs overdue') {
      formatedDate =`Expired on: ${moment(alert.dueDate).format('MM/DD/YYYY')}`;
    } 
    return formatedDate
  }

  function _displayAlertRecipientNames(alert, alertRecipients) {
    let vmNames = [];
    let alertRecipientNames = [];
    const vendorManagers = [];
    const alertRecipientList = [];
    const recipientsAll = [];
    if(alertRecipients && alertRecipients.length > 0){
      alertRecipients.forEach((alert) => {
        if(alert.isVendorManager == true){
          vmNames.push(alert.name);
          vendorManagers.push(alert);
        } else {
          alertRecipientNames.push(alert.name);
          alertRecipientList.push(alert);
        }             
      })
      if(alertRecipientNames && alertRecipientNames.length > 0){
         const alertRecipientName = ` ${alertRecipientNames.join(', ')}`;         
         recipientsAll.push({recipientType: 'Alert Recipients:', recipientName: alertRecipientName, recipients: alertRecipientList});
      } else {
        recipientsAll.push({recipientType: 'Alert Recipients:', recipientName: '', recipients: [], isSelected: false});
      }

      if(vmNames && vmNames.length > 0){
        const vendorManagerName = ` ${vmNames.join(', ')}`;   
        recipientsAll.push({recipientType: 'Vendor Managers:', recipientName: vendorManagerName, recipients: vendorManagers});
      } else {
        recipientsAll.push({recipientType: 'Vendor Managers:', recipientName: '', recipients: [], isSelected: false});
      }
       
    } else {
      alert.nonSelectable =true;
      alert.isSelected = false;
      recipientsAll.push({recipientType: 'Alert Recipients:', recipientName: '', recipients: [], isSelected: false});
      recipientsAll.push({recipientType: 'Vendor Managers:', recipientName: '', recipients: [], isSelected: false});
    }
    alert.recipientList = recipientsAll;
  }
}

SendNotificationsDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'ssDialogService',
  'alerts',
  'loaderService',
  'vmDataService',
  'vmSharedModelService',
];
